import React from 'react'

const CamposWhatsApp = ({ state, handleInputChangeEnlace, codigosPais, generarEnlaceWhatsApp }) => {
  return (
    <div className="space-y-4 p-4 bg-green-50 rounded-lg border border-green-200">
      <h4 className="font-semibold text-green-800 flex items-center gap-2">
        <i className="fab fa-whatsapp"></i>
        Configuración de WhatsApp
      </h4>
      
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Código País
          </label>
          <div className="relative">
            <i className="fas fa-flag absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <select
              value={state.enlace.codigoPais}
              onChange={(e) => handleInputChangeEnlace('codigoPais', e.target.value)}
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              {codigosPais.map((pais) => (
                <option key={pais.codigo} value={pais.codigo}>
                  {pais.bandera} {pais.codigo} {pais.nombre}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="space-y-2 col-span-2">
          <label className="block text-sm font-medium text-gray-700">
            Número de WhatsApp <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <i className="fab fa-whatsapp absolute left-3 top-1/2 transform -translate-y-1/2 text-green-500"></i>
            <input
              type="text"
              placeholder="1234567890"
              value={state.enlace.numeroWhatsApp}
              onChange={(e) => handleInputChangeEnlace('numeroWhatsApp', e.target.value)}
              required
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Mensaje Predefinido (opcional)
        </label>
        <div className="relative">
          <i className="fas fa-comment absolute left-3 top-3 text-gray-400"></i>
          <textarea
            placeholder="¡Hola! Me interesa saber más sobre..."
            value={state.enlace.mensajePredefinido}
            onChange={(e) => handleInputChangeEnlace('mensajePredefinido', e.target.value)}
            rows={3}
            className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          />
        </div>
      </div>
      
      {state.enlace.numeroWhatsApp && (
        <div className="p-3 bg-green-100 rounded-lg">
          <p className="text-sm text-green-800 mb-2">
            <i className="fas fa-eye mr-2"></i>
            Vista previa del enlace:
          </p>
          <a
            href={generarEnlaceWhatsApp(state.enlace.codigoPais, state.enlace.numeroWhatsApp, state.enlace.mensajePredefinido)}
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-600 hover:text-green-700 text-sm break-all"
          >
            {generarEnlaceWhatsApp(state.enlace.codigoPais, state.enlace.numeroWhatsApp, state.enlace.mensajePredefinido)}
          </a>
        </div>
      )}
    </div>
  )
}

export default CamposWhatsApp 